import mimetype from 'mime-types';

export const getFileExtension = (fileName: string) => {
  const type = mimetype.contentType(fileName);

  if (!type) return fileName.split('.').pop();

  return mimetype.extension(type);
};

export const restrictWhitelistMap = (
  whitelistMap: Record<string, string[]> | null,
  acceptedExtensions: string[] | undefined
): Record<string, string[]> | null => {
  if (!acceptedExtensions) return whitelistMap;

  const accepted = acceptedExtensions.map(extension => extension.toLowerCase());
  if (!whitelistMap) return { accepted };

  return Object.fromEntries(
    Object.entries(whitelistMap)
      .map(([category, extensions]): [string, string[]] => [
        category,
        extensions.filter(extension => accepted.includes(extension))
      ])
      .filter(([, extensions]) => extensions.length > 0)
  );
};

export const isExtensionAllowed = (
  allowedExtensions: string[] | undefined,
  fileName: string
) => {
  if (!allowedExtensions) return true;

  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  return allowedExtensions.includes(extension);
};
